import { useEffect, useState } from 'react';
import { qrDataUrl } from '../../lib/portail';

// QR code du lien de suivi, imprimé sur les documents remis au tiers.
export const QrLien = ({ url, legende, taille = 96 }) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (url) qrDataUrl(url).then(setSrc);
  }, [url]);

  if (!src) return null;

  return (
    <div data-testid="qr-lien" className="flex flex-col items-center gap-1">
      <img src={src} alt="QR code de suivi" style={{ width: taille, height: taille }} />
      <p className="max-w-[120px] text-center text-[9px] leading-tight text-slate-600">{legende}</p>
    </div>
  );
};
